(() => {
  if (window.rmBannerSliders) return;
  const instances = new Map();
  function init(root = document) {
    root.querySelectorAll('.icb-slider').forEach((slider) => {
      if (instances.has(slider)) return;
      const slides = [...slider.querySelectorAll('.icb-slide')];
      if (!slides.length) return;
      const events = new AbortController();
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0, timer, transitionTimer, warmupTimer, busy = false, destroyed = false;
      let touchStart = 0;
      const wrapper = slider.parentElement;
      async function prepare(index) {
        const slide = slides[index];
        slide.querySelectorAll('[data-icb-srcset], [data-icb-src]').forEach((el) => {
          for (const attr of ['srcset', 'src']) {
            const value = el.getAttribute(`data-icb-${attr}`);
            if (value) { el.setAttribute(attr, value); el.removeAttribute(`data-icb-${attr}`); }
          }
          if (el.tagName === 'IMG') el.loading = 'eager';
        });
        const image = slide.querySelector('img.icb-bg-img');
        if (!image) return true;
        try { await image.decode(); } catch (_) { return image.complete && image.naturalWidth > 0; }
        return true;
      }
      function stop() { clearInterval(timer); }
      function start() { stop(); if (slides.length > 1 && !document.hidden) timer = setInterval(() => go(current + 1), 5000); }
      async function go(index, direction = 'next') {
        index = (index + slides.length) % slides.length;
        if (busy || index === current || destroyed) return;
        busy = true;
        if (!await prepare(index) || destroyed) { busy = false; return; }
        const previous = slides[current], next = slides[index];
        if (slider.classList.contains('icb-slider--lcp-safe') && !reduce.matches) {
          next.style.transition = 'none';
          next.style.transform = direction === 'prev' ? 'translateX(-100%)' : 'translateX(100%)';
          next.classList.remove('active');
          void next.offsetHeight;
          next.style.transition = '';
          next.style.transform = '';
          next.classList.add('active');
          previous.classList.remove('active');
          previous.style.transform = direction === 'prev' ? 'translateX(100%)' : 'translateX(-100%)';
          transitionTimer = setTimeout(() => {
            previous.style.transition = 'none'; previous.style.transform = '';
            void previous.offsetHeight; previous.style.transition = ''; busy = false;
          }, 620);
        } else {
          previous.classList.remove('active'); next.classList.add('active'); busy = false;
        }
        current = index;
        if (slides.length > 1) warmupTimer = setTimeout(() => { if (!destroyed) prepare((current + 1) % slides.length); }, 1000);
      }
      const options = { signal: events.signal };
      wrapper.querySelector('.icb-arrow-prev')?.addEventListener('click', (e) => { e.preventDefault(); go(current - 1, 'prev'); start(); }, options);
      wrapper.querySelector('.icb-arrow-next')?.addEventListener('click', (e) => { e.preventDefault(); go(current + 1); start(); }, options);
      slider.addEventListener('touchstart', (e) => { touchStart = e.changedTouches[0].screenX; stop(); }, { ...options, passive: true });
      slider.addEventListener('touchend', (e) => {
        const distance = e.changedTouches[0].screenX - touchStart;
        if (Math.abs(distance) > 50) go(current + (distance < 0 ? 1 : -1), distance < 0 ? 'next' : 'prev');
        start();
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start(), options);
      instances.set(slider, {
        select: (index) => { stop(); go(index); },
        destroy: () => { destroyed = true; stop(); clearTimeout(transitionTimer); clearTimeout(warmupTimer); events.abort(); instances.delete(slider); }
      });
      const firstImage = slides[0].querySelector('img.icb-bg-img');
      const warm = () => { if (slides.length > 1) warmupTimer = setTimeout(() => { if (!destroyed) prepare(1); }, 1000); };
      if (!firstImage || firstImage.complete) warm();
      else firstImage.addEventListener('load', warm, { ...options, once: true });
      start();
    });
  }
  window.rmBannerSliders = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    instances.forEach((instance, slider) => { if (e.target.contains(slider)) instance.destroy(); });
  });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.icb-slide');
    if (slide) instances.get(slide.closest('.icb-slider'))?.select(Number(slide.dataset.index));
  });
})();
